<sc-flex vertical stretchContent fitHeight>
  <sc-dialog-title>
    <sc-dictionary-label [dictionaryKey]="titleDictionaryKey"></sc-dictionary-label>
  </sc-dialog-title>

  <sc-flex-fitting-content vertical class="no-field-space">
    <sc-master-detail [data]="listEntries" [readOnly]="true" [selection]="[selectedEntry]"
      (selectionChanged)="handleSelectionChange($event)">
      <sc-padding fitHeight>
        <sc-scroll-pane>

          @if (selectedIndex===0) {
            <app-visit-masterdata [visit]="visit" [types]="types"
              [upfrontRegistration]="upfrontRegistration"
              (masterdataValidityChanged)="onMasterdataValidityChanged($event)"
              (openMandatoryTasksChanged)="onOpenTasksChanged($event)" [inEditMode]="inEditMode"
              [registerArrival]="visit.registerEntrance">
            </app-visit-masterdata>
          }

          @if (selectedIndex===1) {
            <app-visit-visited [visit]="visit"></app-visit-visited>
          }

          @if (selectedIndex===2) {
            <app-visit-group [visit]="visit"></app-visit-group>
          }

          @if (selectedIndex===3) {
            <app-visit-tasks [visit]="visit" [upfrontRegistration]="upfrontRegistration"
            (openMandatoryTasksChanged)="onOpenTasksChanged($event)"></app-visit-tasks>
          }

          @if (selectedIndex===4) {
            <app-visit-log [visit]="visit"></app-visit-log>
          }

        </sc-scroll-pane>
      </sc-padding>
    </sc-master-detail>
  </sc-flex-fitting-content>

  <form [formGroup]="formGroup">

    @if (hasMandatoryOpenTasks) {
      <div class="tasks-hint">
        <sc-flex>
          <sc-content-spacer grow></sc-content-spacer>
          <sc-dictionary-label dictionaryKey="tmc-visit.ui.visit.open-tasks-hint"></sc-dictionary-label>
        </sc-flex>
      </div>
    }
    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>
    <sc-actionbar>

      <sc-content-spacer grow></sc-content-spacer>

      @if (showRegisterEntrance) {
        <sc-checkbox-field formControlName="registerEntrance"
        labelDictionaryKey="tmc.visit.action.register-entrance"></sc-checkbox-field>
        <sc-content-spacer></sc-content-spacer>
      }
      <sc-cancel-button mat-dialog-close></sc-cancel-button>

      @if (!readOnly) {
        <sc-content-spacer></sc-content-spacer>
        <sc-save-button primary (click)="save()" [disabled]="!masterdataValid || this.hasMandatoryOpenTasks"></sc-save-button>
      }
    </sc-actionbar>
  </form>
</sc-flex>
